import { useRef, useCallback, useEffect } from "react";

type Timer = ReturnType<typeof setTimeout>;
type SomeFunction = (...args: any[]) => void;

export default function useDebounce<Func extends SomeFunction>(func: Func,delay: number) {
    const timerRef = useRef<Timer | undefined>(undefined);

    const debouncedFunction = useCallback((...args: Parameters<Func>) => {
        if (timerRef.current) {
            clearTimeout(timerRef.current);
        }
        timerRef.current = setTimeout(() => {
            func(...args);
        }, delay);
    }, [func, delay]);

    // Cleanup function
    const cancel = useCallback(() => {
        if (timerRef.current) {
            clearTimeout(timerRef.current);
            timerRef.current = undefined;
        }
    }, []);

    // Cleanup on unmount
    useEffect(() => {
        return cancel;
    }, [cancel]);

    return { debouncedFunction, cancel };
}
